import { Variable } from '@libraryComponents/ScriptValueDialog/types'

import { FIELD_VALUE_TYPE } from '@constants'
import { ObjectFieldDTO } from '@types'

const mapFieldValueTypeToTypeScript = (valueType: string): string => {
  switch (valueType) {
    case FIELD_VALUE_TYPE.STRING:
      return 'string'
    case FIELD_VALUE_TYPE.INTEGER:
    case FIELD_VALUE_TYPE.DOUBLE:
      return 'number'
    case FIELD_VALUE_TYPE.BOOLEAN:
      return 'boolean'
    case FIELD_VALUE_TYPE.DATETIME:
      return 'Date | string'
    case FIELD_VALUE_TYPE.BINARY:
      return 'Uint8Array | Blob | string'
    case FIELD_VALUE_TYPE.OBJ_PK_LINK:
    case FIELD_VALUE_TYPE.OBJ_INTERNAL_ID_LINK:
      return 'number | string'
    case FIELD_VALUE_TYPE.OBJ_EMBEDDED:
      return 'any'
    default:
      return 'any'
  }
}

export const convertObjectFieldsToVariables = (objectFields: ObjectFieldDTO[]): Variable[] => {
  if (!objectFields || objectFields.length === 0) {
    return []
  }

  return objectFields.map(field => {
    const valueType = String(field.valueType || '')
    const fieldType = mapFieldValueTypeToTypeScript(valueType)

    return {
      name: field.name,
      type: fieldType,
      description: field.desc,
    } as Variable
  })
}
